import { ImageCustom } from '../Image';
import {
  Postsbox,
  DescriptionWrapper,
  Title,
  Description,
  BoxTitle,
} from './style';

type ImageWrapperProps = {
  post: {
    imgAlt: string;
    img: string;
    title: string;
    description: string
  };
};

const BrandsWrapper = ({ post }: ImageWrapperProps) => {
  return (
    <div className="descriptionwrapper">
      <Postsbox key={post.imgAlt} >
        <ImageCustom src={post.img} alt={post.imgAlt} />
        <DescriptionWrapper>
          <BoxTitle>
            <Title>{post.title}</Title>
            <Description dangerouslySetInnerHTML={{ __html: post.description }}></Description>
          </BoxTitle>
        </DescriptionWrapper>
      </Postsbox>
    </div>
  );
}

export default BrandsWrapper;
